import axios from 'axios';
const { REACT_APP_URL } = process.env;

const axiosHelper = (props) => {
  const {
    method = 'get',
    url = '/',
    data = {},
    token = '',
    successMethod = (res) => console.log(res),
    failureMethod = (err) => console.log(err),
  } = props;

  const baseURL = REACT_APP_URL;

  return axios({
    method,
    url: baseURL + url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
    },
    data,
  })
    .then(successMethod)
    .catch(failureMethod);
};

export default axiosHelper;
